import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { RoundButton } from '../RoundButton';
import { DimensionsContext } from 'context/DimensionsContext';
import ActionSheet from 'react-native-actions-sheet';

const closeIcon = require('assets/close.svg');

function DesktopView({ testID, children, dismiss }) {
  return (
    <View style={desktopStyles.container} testID={testID}>
      <View style={desktopStyles.closeButton}>
        <RoundButton
          image={closeIcon}
          onPress={dismiss}
          color="#d3d3d3"
          size={40}
        />
      </View>
      {children}
    </View>
  );
}

export function DraggableSheet({
  id,
  children,
  dismiss,
  testID = 'DraggableSheet',
  open = false,
}) {
  const dimensions = useContext(DimensionsContext);
  if (dimensions.size === 'large') {
    if (open) {
      return (
        <DesktopView testID={testID} children={children} dismiss={dismiss} />
      );
    } else {
      return <></>;
    }
  }

  return (
    <ActionSheet gestureEnabled={true} id={id} containerStyle={style.container}>
      {children}
    </ActionSheet>
  );
}

const desktopStyles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    height: '100%',
    width: '20%',
    minWidth: 400,
    zIndex: 9999,
    backgroundColor: '#fff',
    padding: 20,
    shadowRadius: 5,
    shadowOpacity: 0.1,
    overflowY: 'auto',
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 9999,
  },
});

const style = StyleSheet.create({
  container: {
    padding: 10,
  },
});
